import { HStack } from '@chakra-ui/react'
import ImageBox from 'components/common/ImageBox'
import IfopNavigation from 'components/markdown/components/IfopNavigation'
import { FC } from 'react'

const IfopPoliticalSexPositionsNavigation: FC = () => {
  return (
    <>
      <IfopNavigation
        title="Relações entre sexo e posição política | Pesquisa Datafolha e Omens"
        links={[
          {
            to: '/sexo-e-posicao-politica/',
            content: (
              <HStack>
                <ImageBox alt="graph" src="/icons/open-iconic/svg/graph.svg" height="12" width="12" />
                <span>Ver o relatório</span>
              </HStack>
            )
          },
          {
            to: '/pesquisa-sexo-e-posicao-politica/',
            content: (
              <HStack>
                <ImageBox alt="book" src="/icons/open-iconic/svg/book.svg" height="12" width="12" />
                <span>Ver a pesquisa completa</span>
              </HStack>
            )
          }
        ]}
      />
    </>
  )
}

export default IfopPoliticalSexPositionsNavigation
